import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'sm-attendance-marker',
  templateUrl: './attendance-marker.component.html',
  styleUrls: ['./attendance-marker.component.scss']
})
export class AttendanceMarkerComponent implements OnInit {
  note:any = ''
  constructor(public activeModal :  MatDialogRef<AttendanceMarkerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
  }
  public decline() {
    this.activeModal.close(false);
  }

  public accept() {
    this.activeModal.close({
      note: this.note
    });
  }

  public dismiss() {
    this.activeModal.close();
  }

}
